import { HUB_PAGE_IDS, hubUrl } from '@/features/whatsapp/hubConfig'
import { NOTIFY_MOVED_IDS, notifyHubUrl } from '@/features/notifications/notifyHubConfig'

/**
 * Pages whose screen now lives as a tab of a home page (واتساب, الإشعارات والتنبيهات): their old address — bookmarks,
 * links in other screens — opens that tab, with the old query kept. Null = the page opens where it is.
 */
export function movedTo(pageId: string, search = ''): string | null {
  if (HUB_PAGE_IDS.has(pageId)) return hubUrl(pageId, search)
  if (NOTIFY_MOVED_IDS.has(pageId)) return notifyHubUrl(pageId, search)
  return null
}

/**
 * The home a moved page now lives in, by its address. A person who may open the moved page but not its home (an HR
 * officer with hr:read only, for «تنبيهات الموارد البشرية» inside الإشعارات والتنبيهات) keeps the page where it was —
 * in the sidebar and at its old address — instead of meeting «ليس لديك صلاحية» (review, 2026-10-29).
 */
export function movedHomePath(pageId: string): string | null {
  const url = movedTo(pageId)
  return url ? url.split('?')[0]! : null
}
